// eslint-disable-next-line import/prefer-default-export
export const aspirationMapper: { [key:string]: string } = {
  na: 'N/A',
  turbocharged: 'Turbocharged',
  supercharged: 'Supercharged',
};
